import CrudManager from "@/components/admin/CrudManager";

export function Brands() {
  return <CrudManager title="Brands" endpoint="/brands" module="brands"
    columns={[
      { key: "logo", label: "Logo", render: (i) => i.logo ? <img src={i.logo} alt="" className="h-9 w-9 rounded object-contain" /> : <span className="grid h-9 w-9 place-items-center rounded bg-secondary text-xs font-bold">{(i.name || "?")[0]}</span> },
      { key: "name", label: "Name" }, { key: "order", label: "Order" },
      { key: "is_active", label: "Active", render: (i) => i.is_active ? "Yes" : "No" },
    ]}
    defaults={{ is_active: true, order: 1 }}
    transform={(f) => ({ ...f, slug: (f.slug || f.name || "").toLowerCase().trim().replace(/\s+/g, "-") })}
    fields={[
      { key: "name", label: "Brand Name", span: 2 },
      { key: "logo", label: "Brand Logo", span: 2, type: "image" },
      { key: "order", label: "Order", type: "number" },
      { key: "is_active", label: "Active", type: "switch" },
    ]} />;
}

export function Categories() {
  return <CrudManager title="Categories" endpoint="/categories" module="categories"
    columns={[
      { key: "image", label: "Image", render: (i) => <img src={i.image} alt="" className="h-9 w-9 rounded object-cover" /> },
      { key: "name", label: "Name" }, { key: "slug", label: "Slug" }, { key: "order", label: "Order" },
      { key: "is_active", label: "Active", render: (i) => i.is_active ? "Yes" : "No" },
    ]}
    defaults={{ is_active: true, order: 1 }}
    fields={[
      { key: "name", label: "Name" }, { key: "slug", label: "Slug" },
      { key: "description", label: "Description", type: "textarea" },
      { key: "image", label: "Image", span: 2, type: "image" }, { key: "order", label: "Order", type: "number" },
      { key: "is_active", label: "Active", type: "switch" },
    ]} />;
}

export function Plans() {
  return <CrudManager title="Installment Plans" endpoint="/plans" module="plans"
    columns={[
      { key: "name", label: "Name" }, { key: "duration_months", label: "Months" },
      { key: "advance_percent", label: "Advance %" }, { key: "registration_fee", label: "Reg Fee" },
      { key: "processing_fee", label: "Proc Fee" }, { key: "business_charge_percent", label: "Business %" },
      { key: "is_active", label: "Active", render: (i) => i.is_active ? "Yes" : "No" },
    ]}
    defaults={{ is_active: true, order: 1, advance_percent: 20, registration_fee: 500, processing_fee: 500, business_charge_percent: 30 }}
    fields={[
      { key: "name", label: "Plan Name", span: 2 }, { key: "duration_months", label: "Duration (months)", type: "number" },
      { key: "advance_percent", label: "Advance %", type: "number" }, { key: "registration_fee", label: "Registration Fee", type: "number" },
      { key: "processing_fee", label: "Processing Fee", type: "number" }, { key: "business_charge_percent", label: "Business Charges %", type: "number" },
      { key: "order", label: "Order", type: "number" }, { key: "is_active", label: "Active", type: "switch" },
    ]} />;
}

export function Deals() {
  return <CrudManager title="Deals" endpoint="/deals" module="deals"
    columns={[
      { key: "image", label: "Image", render: (i) => <img src={i.image} alt="" className="h-9 w-14 rounded object-cover" /> },
      { key: "title", label: "Title" }, { key: "discount_percent", label: "Discount %" },
      { key: "category_slug", label: "Category" }, { key: "is_active", label: "Active", render: (i) => i.is_active ? "Yes" : "No" },
    ]}
    defaults={{ is_active: true, order: 1, discount_percent: 0, button_text: "Grab Deal", button_link: "/products" }}
    fields={[
      { key: "title", label: "Title", span: 2 }, { key: "description", label: "Description", type: "textarea" },
      { key: "image", label: "Image", span: 2, type: "image" }, { key: "discount_percent", label: "Discount %", type: "number" },
      { key: "category_slug", label: "Category Slug" }, { key: "button_text", label: "Button Text" },
      { key: "button_link", label: "Button Link" }, { key: "order", label: "Order", type: "number" },
      { key: "is_active", label: "Active", type: "switch" },
    ]} />;
}

export function Branches() {
  return <CrudManager title="Branches" endpoint="/branches" module="branches"
    columns={[
      { key: "name", label: "Name" }, { key: "code", label: "Code" }, { key: "city", label: "City" },
      { key: "phone", label: "Phone" }, { key: "is_active", label: "Active", render: (i) => i.is_active ? "Yes" : "No" },
    ]}
    defaults={{ is_active: true }}
    fields={[
      { key: "name", label: "Branch Name" }, { key: "code", label: "Code" },
      { key: "city", label: "City" }, { key: "phone", label: "Phone" },
      { key: "address", label: "Address", span: 2 }, { key: "is_active", label: "Active", type: "switch" },
    ]} />;
}
